<template>
  <div class="h1">
    404
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="scss" scoped>
</style>
